import React, { useState, useRef } from "react"
import cx from "classnames"
import { withOrientationChange } from "react-device-detect"
import carret from "@/public/icons/arrow-up.svg"
import { KEYCODE } from "@/constants/index"
import { getAnalyticsData } from "@/components/ProductList/v2/Sort/sortAnalytics"
import useOnClickOutside from "@/hooks/useOnClickOutside"
import { getTranslations } from "@/components/MyFavorites/v1/MyList/localization"
import { useTranslation } from "next-i18next"

const Sort = ({
  texts: {
    sort = "",
    selected = "",
    sortByAria = "",
    altSort = "",
    sortbyExpanded = "",
    sortbyClosed = "",
  },
  data,
  onChange,
  page,
  selectedtab,
  tabIndex = 0,
  isSearch,
  selectedSort,
  isMyFavoriteTab = false,
  isMyList = false,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const sortClass = cx({ sort: true, "sort--open": isOpen })
  const sortBtn = useRef(null)
  const pastServiceMenu = useRef(null)
  const sortByWrapper = useRef(null)
  const { t } = useTranslation("common")
  const staticText = getTranslations(t)

  useOnClickOutside(sortByWrapper, () => {
    isOpen && setIsOpen(false)
  })

  const btnKeyDown = e => {
    switch (e.keyCode) {
      case KEYCODE.ENTER:
        e.preventDefault()
        if (!isOpen) {
          pastServiceMenu.current.firstElementChild.focus()
        }
        setIsOpen(!isOpen)
        break
      case KEYCODE.SPACE:
        e.preventDefault()
        if (!isOpen) {
          pastServiceMenu.current.firstElementChild.focus()
        }
        setIsOpen(!isOpen)
        break
      default:
        break
    }
  }

  const handleKeyDown = (i, e) => {
    e.preventDefault()

    const ele = pastServiceMenu.current.childNodes
    switch (e.keyCode) {
      case KEYCODE.ESC:
        setIsOpen(false)
        break
      case KEYCODE.UP:
        if (i > 0) ele[i - 1].focus()
        break
      case KEYCODE.DOWN:
        if (i < data.length - 1) ele[i + 1].focus()
        break
      case KEYCODE.SPACE:
      case KEYCODE.ENTER:
        ele[i].click()
        sortBtn.current.focus()
        break
      default:
        break
    }
  }

  const handleDatalayer = (item, needsJson, { selectedtab, page }) => {
    const myListTitle = staticText?.myListPageTitle
    return (
      !isMyList &&
      getAnalyticsData(
        item,
        null,
        {
          selectedtab,
          page,
        },
        myListTitle
      )
    )
  }
  return (
    <div className={sortClass} ref={sortByWrapper} aria-description={sort}>
      <button
        ref={sortBtn}
        className="sort__toggle"
        tabIndex={tabIndex}
        role="combobox"
        aria-expanded={isOpen}
        onClick={() => setIsOpen(!isOpen)}
        onKeyDown={btnKeyDown}
        aria-controls="sort-options-list"
      >
        <div className="sort-by-text">{sort} </div>
        <div className="sort-options">
          {` ${isMyFavoriteTab ? "" : ":"} ${
            selectedSort ? selectedSort.name : "Featured"
          }`}
        </div>
        <img
          src={carret?.src}
          alt={altSort}
          className="sort__toggle-icon"
          aria-hidden="true"
        />
      </button>
      <ul
        ref={pastServiceMenu}
        className="sort__drop-down"
        aria-label={
          isOpen
            ? sortbyExpanded || "Sort By Button expanded"
            : sortbyClosed || "Sort By Button Closed"
        }
        id="sort-options-list"
      >
        {data.map((item, i) => {
          return (
            <li
              key={i}
              id={`select-options-${i}`}
              role="option"
              tabIndex="-1"
              aria-selected={item?.name === selectedSort?.name}
              className={`sort__item gbh-data-layer ${
                (item && item.name) === (selectedSort && selectedSort.name)
                  ? "active"
                  : ""
              }`}
              data-gbh-data-layer={handleDatalayer(item, null, {
                selectedtab,
                page,
              })}
              onClick={() => {
                onChange(item)
                setIsOpen(false)
              }}
              onKeyDown={e => handleKeyDown(i, e)}
            >
              {item.name}
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default withOrientationChange(Sort)
